import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path d="M13 6H11V18H13V6Z" xmlns="http://www.w3.org/2000/svg" />,
  "LineM"
);
